<template>
	<div class="swimDetail">
		<!-- 导航栏 -->
		<back-to :title="productList.title"></back-to>
		<!-- 轮播 -->
		<section class="detailSwiper">
			<van-swipe class="detailSwiper-swiper-bg" :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(item, index) in productList.pepeatpic" :key="index">
					<img v-lazy="item.picturePath" />
				</van-swipe-item>
			</van-swipe>
		</section>
		<!-- 价钱 -->
		<section class="swimDetail-common">
			<div class="swimDetail-price_top">
				<font>￥</font>
				<p>{{productList.refPrice}}</p>
				<font>起</font>
			</div>
			<div class="swimDetail-price_title">
				{{productList.title}}
			</div>
			<div class="swimDetail-price_type">
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_01.png?v='+random"
						alt="">
					<p>{{productList.crowdcn}}</p>
					<font>出游人群</font>
				</span>
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_02.png?v='+random"
						alt="">
					<p>{{productList.themecn}}</p>
					<font>出游主题</font>
				</span>
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_03.png?v='+random"
						alt="">
					<p>提前{{productList.advanceDay}}天报名</p>
					<font>报名时间</font>
				</span>
				<span>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_04.png?v='+random"
						alt="">
					<p>{{productList.isForeign == 1? '境外':'国内'}}</p>
					<font>出游类型</font>
				</span>
			</div>
			<div class="swimDetail-price_ad">
				<label for=""><img class="ad5"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_05.png?v='+random"
						alt=""></label>
				<label for=""><img class="ad1"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_06.png?v='+random"
						alt="">
					<p>一手资源</p>
				</label>
				<label for=""><img class="ad1"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_06.png?v='+random"
						alt="">
					<p>15年深耕</p>
				</label>
				<label for=""><img class="ad1"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_06.png?v='+random"
						alt="">
					<p>独家发团</p>
				</label>
				<label for=""><img class="ad7"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_07.png?v='+random"
						alt=""></label>
			</div>
		</section>
		<section class="swimDetail-common swimDetail-serve">
			<span>服务</span>
			<span>
				<img v-if="productList.confirmType != 0" class="ad8"
					:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_08.png?v='+random" alt="">
				<p v-if="productList.confirmType == 2">该商品在线支付成功后需等待客服确认</p>
				<p v-if="productList.confirmType == 0">未选择</p>
			</span>
		</section>
		<section class="swimDetail-common swimDetail-package">
			<div class="swimDetail-package_top">
				<label for="">
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_09.png?v='+random"
						alt="">
					<p>选择套餐</p>
				</label>
				<label for="" @click="next">
					<p>全部团期</p>
					<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_10.png?v='+random"
						alt="">
					</image>
				</label>
			</div>
			<div class="meal-item">
				<p v-for="(item,index) in productList.package" :key="index"
					:class="packegeSelectIndex == index? 'meal-item-change':''" @click="change(index)">{{item.name}}</p>
			</div>
			<div class="date">
				<span v-for="(item,index) in model_date_f" :key="index"
					:class="dateSelectIndex == index? 'data-item-change data-item':'data-item'"
					@click="dateSelectIndex=index">
					<label>{{item.dateFormat|formatDate}}</label>
					<p>￥{{item.enrolls[0].price_01}}起</p>
				</span>
			</div>
		</section>
		<section class="swimDetail-sticky">
			<van-tabs v-model="active" scrollspy sticky offset-top="46" color="#ffcc03">
				<van-tab title="商品详情">
					<!-- 基本信息 -->
					<section class="swimDetail-common swimDetail-sticky_basic">
						<h2 class="swimDetail-sticky_title">基本信息</h2>
						<ul>
							<li>
								<h3>产品亮点</h3>
								<label for="">
									<p v-for="(item,index) in productList.strengths">{{item.strength}}</p>
								</label>
							</li>
							<li>
								<h3>行程天数</h3>
								<label for="">{{productList.day}}天{{productList.night}}晚</label>
							</li>
							<li>
								<h3>出发地</h3>
								<label for="">{{productList.pods}}</label>
							</li>
							<li>
								<h3>目的地</h3>
								<label for="">{{productList.destinations}}</label>
							</li>
						</ul>
					</section>
					<!-- 行程介绍 -->
					<section class="swimDetail-common swimDetail-sticky_trip">
						<h2 class="swimDetail-sticky_title">行程介绍</h2>
						<div class="swimDetail-sticky_package">
							<label for="">套餐:</label>
							<p>{{productListPackage.name}}</p>
						</div>
						<div class="swimDetail-sticky_Collapse">
							<van-collapse v-model="activeName" accordion>
								<van-collapse-item v-for="(item,index) in productListPackage.schedules" :key="index"
									:name="index">
									<template #title>
										<div class="sticky_Collapse-title">
											<span>
												<label for="">{{item.day < 10? '0'+item.day:item.day}}</label>
												<p>DAY</p>
											</span>
											<span>{{item.subject}}</span>
										</div>
									</template>
									<template>
										<div class="sticky_Collapse-content">
											<span class="sticky_Collapse-content01">
												<label for="" class="content01-t">
													<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_15.png?v='+random"
														alt="">
													<font>详情</font>
												</label>
												<label for="" class="content01-b">
													<div v-html="item.info"></div>
												</label>
											</span>
											<span class="sticky_Collapse-content02">
												<label for="" class="content01-t">
													<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_16.png?v='+random"
														alt="">
													<font>
														早餐{{item.meals.length>=1 && item.meals[0].Myself==1?"自理":item.meals[0].Detail}},午餐{{item.meals.length>=2&&item.meals[1].Myself==1?"自理":item.meals[1].Detail}},晚餐{{item.meals.length>=3&&item.meals[2].Myself==1?"自理":item.meals[2].Detail}}
													</font>
												</label>
												<label for="" class="content01-b"></label>
											</span>
											<span class="sticky_Collapse-content03">
												<label for="" class="content01-t">
													<img :src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/newparticular_17.png?v='+random"
														alt="">
													<font>{{item.hotel.Details}}</font>
												</label>
											</span>
										</div>
									</template>
								</van-collapse-item>
							</van-collapse>
						</div>
					</section>
					<!-- 产品概况 -->
					<section class="swimDetail-common swimDetail-sticky_overview">
						<h2 class="swimDetail-sticky_title">产品概况</h2>
						<div v-html="productList.mark"></div>
					</section>
				</van-tab>
				<van-tab title="费用说明">
					<section class="swimDetail-common">
						<h2 class="swimDetail-sticky_title">费用说明</h2>
						<div class="swimDetail-sticky_cost" v-for="(item,index) in productList.instructions"
							:key="index">
							<h3>{{item.title}}</h3>
							<div v-html="item.content"></div>
						</div>
					</section>
				</van-tab>
				<van-tab title="其他信息">
					<section class="swimDetail-common">
						<h2 class="swimDetail-sticky_title">其他信息</h2>
						<div class="swimDetail-sticky_cost" v-for="(item,index) in productList.others" :key="index">
							<h3>{{item.title}}</h3>
							<div v-html="item.content"></div>
						</div>
					</section>
				</van-tab>
			</van-tabs>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<a href="tel:02425836666">咨询</a>
			<span class="" @click="next">立即下单</span>
			<!-- <span v-else class="grays">选择购买</span> -->
		</section>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'swimDetail',
		components: {
			BackTo
		},
		data() {
			return {
				productListPackage: [],
				productList: [],
				model_date_f: [],
				random: Math.random(),
				packegeSelectIndex: 0,
				dateSelectIndex: 0,
				active: 0,
				activeName: 0
			}
		},
		filters: {
			formatDate(date) {
				let getMonth = new Date(date).getMonth() + 1;
				let getDate = new Date(date).getDate();
				return `${getMonth}/${getDate}`
			}
		},
		created() {
			this.id = this.$route.query.id
		},
		mounted() {
			this.getData()
		},
		methods: {
			next() {
				if (this.model_date_f.length < 1) {
					Toast('暂无团期');
					return
				}
				this.$router.push({
					path: '/groupPackage',
					query: {
						'id': this.$route.query.id,
						'packegeSelectIndex': this.packegeSelectIndex,
						'dateSelectIndex': this.dateSelectIndex
					}
				})
			},
			getData() {
				var jsonData = {
					packagecompany: "," + this.$platformid + ",",
					id: this.$route.query.id
				}
				this.$_post(
					this.$connectHttpDayun + '/team/api/teamgetfxwd', jsonData
				).then(res => {
					console.log(res)
					res.object.crowdcn = res.object.crowdcn.split(',')[0]
					res.object.themecn = res.object.themecn.split(',')[0]
					// 出发地重组
					let podstr = ""
					res.object.pods.forEach((ele, i) => {
						if (i + 1 == res.object.pods.length) {
							podstr = podstr + ele.pod
						} else {
							podstr = podstr + ele.pod + '、'
						}
					})
					// 目的地
					let destinationsStr = ''
					res.object.destinations.forEach((ele, i) => {
						if (i + 1 == res.object.destinations.length) {
							destinationsStr = destinationsStr + ele.destination
						} else {
							destinationsStr = destinationsStr + ele.destination + '、'
						}
					})
					res.object.pods = podstr
					res.object.destinations = destinationsStr
					this.productList = res.object
					this.connectDate(res.object.package)
				})
			},
			// 操作 详情返回值
			connectDate(data) {
				let gctemplate = ''
				if (data[this.packegeSelectIndex].gctemplate.length == 0) {
					gctemplate = '0'
				} else {
					gctemplate = data[this.packegeSelectIndex].gctemplate[0].id
				}

				var jsonData = {
					object: {
						packageID: data.length > 0 ? data[this.packegeSelectIndex].id : 0,
						gctemplate: gctemplate
					}
				}

				this.$_post(
					this.$connectHttpDayun + '/teamquery/get/wxapp/silist', jsonData
				).then(res => {
					let now = new Date().getMonth() + 1;
					let arr = [];
					res.objects = res.objects.sort((a, b) => a.date - b.date)
					res.objects.forEach((item, i) => {
						let getMonth = new Date(item.dateFormat).getMonth() + 1;
						if (getMonth == now) {
							arr.push(item)
						}
					})
					this.model_date_f = arr
					data[this.packegeSelectIndex].schedules.forEach((item, i) => {
						item.hotel = JSON.parse(item.ext_Hotel)
						item.meals = JSON.parse(item.ext_Meals)
					})
					this.productListPackage = data[this.packegeSelectIndex]
				})
			},
			change(index) {
				if (this.packegeSelectIndex == index) {
					return
				}
				this.packegeSelectIndex = index
				this.dateSelectIndex = 0
				this.connectDate(this.productList.package)
			}
		}
	}
</script>
<style>
	.swimDetail .detailSwiper,
	.swimDetail .detailSwiper-swiper-bg {
		width: 100%;
		height: 700px;
		z-index: -1
	}

	.swimDetail .detailSwiper-swiper-bg img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	.swimDetail-common {
		width: 100%;
		border-bottom: 20px solid #f7f7f7;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.swimDetail-price_top {
		font-size: 48px;
		color: #ff401a;
		display: flex;
		align-items: baseline;
		padding: 18px 0 12px 0;
	}

	.swimDetail-price_top font {
		padding: 0 6px;
		font-size: 36px;
	}

	.swimDetail-price_title {
		font-size: 32px;
		color: #333;
		font-weight: bold;
	}

	.swimDetail-price_type {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 36px 0 30px 0;
		border-bottom: 1px solid #e6e6e6;
	}

	.swimDetail-price_type img {
		height: 33px;
		width: 33px;
		margin-bottom: 12px;
	}

	.swimDetail-price_type span {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #333;
		flex: 1;
	}

	.swimDetail-price_type font {
		font-size: 22px;
		color: #919499
	}

	.swimDetail-price_ad {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
		height: 88px;
		width: 100%;
	}

	.swimDetail-price_ad label {
		display: flex;
		align-items: center;
	}

	.swimDetail-price_ad p {
		font-size: 24px;
		color: #919499;
		margin-left: 8px;
	}

	.swimDetail-price_ad .ad5 {
		width: 132px;
		height: 39px;
	}

	.swimDetail-price_ad .ad1 {
		height: 26px;
		width: 26px;
		margin-left: 20px;
	}

	.swimDetail-price_ad .ad7 {
		height: 20px;
		width: 10px;

	}

	.swimDetail-price_ad label:last-child {
		margin-left: auto;
	}

	.swimDetail-serve {
		padding-top: 28px;
		padding-bottom: 28px;
		display: flex;
	}

	.swimDetail-serve p {
		font-size: 24px;
		color: #333;
		margin-top: 24px;
	}

	.swimDetail-serve span {
		font-size: 24px;
		color: #919499;
		margin-right: 20px;
		display: grid;
	}

	.swimDetail-serve .ad8 {
		width: 110px;
		height: 26px;
		margin-top: 4px;
	}

	.swimDetail-package_top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 88px;
	}

	.swimDetail-package_top label {
		display: flex;
		align-items: baseline;
	}

	.swimDetail-package_top label:first-child {
		font-size: 32px;
		color: #333;
		font-weight: bold;
	}

	.swimDetail-package_top label:first-child img {
		height: 24px;
		width: 20px;
		margin-right: 10px;
	}

	.swimDetail-package_top label:last-child {
		color: #fca537;
		font-size: 24px;

	}

	.swimDetail-package_top label:last-child img {
		height: 20px;
		width: 10px;
		margin-left: 10px;
	}

	.meal-item {
		display: flex;
		flex-wrap: wrap;
		margin-top: 14px;
	}

	.meal-item p {
		height: 56px;
		color: #333;
		text-align: center;
		padding: 0 20px;
		border-radius: 200px;
		background: #fff;
		border: 1px solid #f1f1f1;
		line-height: 56px;
		margin-top: 10px;
		margin-right: 10px;
		font-size: 24px;
	}

	.meal-item-change {
		background: #ffcc03 !important;
	}

	.date {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin: 32px auto 26px;
		box-sizing: border-box;
	}

	.data-item {
		border: 1px solid #f1f1f1;
		height: 90px;
		width: 128px;
		text-align: center;
		font-size: 24px;
		margin-left: 10px;
		border-radius: 5px;
		margin-bottom: 10px;
	}

	.data-item-change {
		border: 1px solid#fca500 !important;
	}

	.data-item label {
		color: #333;
		font-weight: bold;
		margin-top: 15px;
		display: inline-block;
	}

	.data-item p {
		color: #ff5e00;
	}

	.swimDetail-sticky_title {
		height: 88px;
		line-height: 88px;
		font-size: 32px;
		color: #333;
	}

	.swimDetail-sticky_basic li {
		border-top: 1px solid #f1f1f1;
		display: flex;
		padding: 15px 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	.swimDetail-sticky_basic h3 {
		line-height: 75px;
		font-size: 24px;
		color: #999;
		width: 176px;
		text-align: left;
		font-weight: normal;
	}

	.swimDetail-sticky_basic label {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		font-size: 24px;
	}

	.swimDetail-sticky_basic p {
		height: 40px;
		line-height: 40px;
		background: #f1f1f1;
		color: #333;
		padding: 0 10px;
		margin-right: 8px;
		margin-bottom: 8px;
	}

	.swimDetail-sticky_package {
		display: flex;
		align-items: center;
		font-size: 28px;
		color: #333;
		margin-top: 20px;
	}

	.swimDetail-sticky_package p {
		height: 56px;
		margin-left: 30px;
		background: #ffcc03;
		font-size: 24px;
		text-align: center;
		line-height: 56px;
		border-radius: 200px;
		padding: 0 24px;
	}

	.swimDetail-sticky_Collapse {
		width: 100%;
		margin-top: 32px;
	}

	.sticky_Collapse-title {
		display: flex;
		align-items: center;

	}

	.sticky_Collapse-title span:first-child {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 70px;
		height: 80px;
		border-right: 1px solid #333;
		font-size: 24px;
		color: #666;
	}

	.sticky_Collapse-title label {
		font-size: 32px;
		color: #333;
		font-weight: bold;
	}

	.sticky_Collapse-title span:last-child {
		margin-left: 22px;
		font-size: 30px;
		font-weight: bold;
		display: flex;
		align-items: center;
	}

	.swimDetail-sticky .van-cell {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.swimDetail-sticky .van-cell::after,
	.swimDetail-sticky .van-collapse-item--border::after {
		width: 100%;
		left: 0;
	}

	.sticky_Collapse-content {
		display: flex;
		flex-direction: column;
	}

	.sticky_Collapse-content img {
		height: 40px;
		width: 40px;
	}

	.swimDetail-sticky .van-collapse-item__content {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.sticky_Collapse-content font {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		margin-left: 20px;
	}

	.content01-b {
		margin-left: 20px;
		border-left: 1px solid #f1f1f1;
		padding-left: 40px;
		box-sizing: border-box;
		display: block;
		padding-bottom: 40px;
	}

	.content01-b div {
		width: 550px;
	}

	.content01-t {
		display: flex;
	}

	.swimDetail-sticky_overview div {
		font-size: 26px;
		line-height: 48px;
		color: #666;
		padding-bottom: 20px;
	}

	.swimDetail-sticky_cost {
		margin-bottom: 30px;
	}

	.swimDetail-sticky_cost h3 {
		font-size: 26px;
		color: #333;
		font-weight: bold;
		display: flex;
		align-items: center;
		position: relative;
	}

	.swimDetail-sticky_cost h3::before {
		content: "*";
		color: #ffcc03;
		font-size: 24px;
		margin-top: 5px;
		margin-right: 20px;
	}

	.swimDetail-sticky_cost div {
		margin-top: 24px;
		margin-left: 26px;
		margin-right: 0;
		font-size: 22px;
		color: #666;
		line-height: 48px;
	}
</style>